export const EMPLOYER_TRAUMA_INCIDENTS_ROUTE = '/employer/trauma/incidents';

export const employerTraumaIncidentDetailRoute = (incidentId: number): string =>
  `${EMPLOYER_TRAUMA_INCIDENTS_ROUTE}/${incidentId}`;

export const EMPLOYER_TRAUMA_STAFF_DASHBOARD_ROUTE = '/employer/trauma';

export const EMPLOYER_TRAUMA_INCIDENTS_PAGE_TITLE = 'Trauma Support - Incidents';

export const EMPLOYER_TRAUMA_INCIDENTS_PAGE_SUBTITLE =
  'All active incidents logged for your organisation. Click View to see individual staff records.';

export const EMPLOYER_TRAUMA_INCIDENTS_TABLE_TITLE = 'Trauma Incidents';

export const EMPLOYER_TRAUMA_INCIDENTS_TABLE_SUBTITLE =
  'All active incidents - click View to see individual staff records.';

export const EMPLOYER_TRAUMA_INCIDENTS_TABLE_EMPTY_TEXT = 'No incidents match this filter.';

export const EMPLOYER_TRAUMA_INCIDENTS_STAFF_VIEW_LABEL = 'STAFF VIEW';

export const EMPLOYER_TRAUMA_INCIDENTS_VIEW_LABEL = 'INCIDENTS VIEW';

export const EMPLOYER_TRAUMA_INCIDENT_DETAIL_BACK_LABEL = '← Back to all incidents';

export const EMPLOYER_TRAUMA_INCIDENT_ADD_STAFF_LABEL = '+ ADD STAFF';
